import React, { useMemo } from "react"
import { useDocuments, useDocument } from "@/lib/queries"
import { SupplementalListView } from "@/components/shared/SupplementalListView"

export function SupplementalListPage() {
  const { data: groups, isLoading } = useDocuments()

  const docs = useMemo(
    () =>
      groups?.find((g) => g.document_type === "supplemental")?.documents ?? [],
    [groups]
  )

  return (
    <SupplementalListView
      docs={docs}
      isLoading={isLoading}
      useDocumentDetail={useDocument}
    />
  )
}
